import { render, staticRenderFns } from "./platform_list_yaofang.vue?vue&type=template&id=71810308&scoped=true&"
import script from "./platform_list_yaofang.vue?vue&type=script&lang=js&"
export * from "./platform_list_yaofang.vue?vue&type=script&lang=js&"
import style0 from "./platform_list_yaofang.vue?vue&type=style&index=0&id=71810308&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71810308",
  null
  
)

export default component.exports